import script from "./JobPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./JobPanel.vue?vue&type=script&setup=true&lang=js"

import "./JobPanel.vue?vue&type=style&index=0&id=201dcf4a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201dcf4a"]])

export default __exports__